import styled from 'styled-components';
import { colors } from 'global/colors';

export const ConsoleContainer = styled.div`
  overflow-y: hidden;
  height: 100%;
`;

export const ConsoleScrollContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  margin: 5px;
`;

export const ConsoleLogStep = styled.span`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.freecode.color};
  padding-bottom: 5px;
`;

export const ConsoleLogStepNumber = styled.p`
  font-size: small;
  margin: 0px;
  color: ${({ theme }) => theme.freecode.color};
`;

export const BoldHover = styled.b`
  cursor: pointer;
`;

export const ConsoleText = styled.p`
  margin: 0px;
  font-family: 'Ubunto mono', monospace;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.freecode.color};
  ${({ tag, theme }) => tag === 'challenge' && `color:  ${theme.freecode.activeAreaColor};`}
  ${({ pipe }) => pipe === 'err' && `color: ${colors.red};`};
`;

export const Table = styled.table`
  margin: 5px;
  width: 100%;
  margin-top: 0;
`;

export const TableHead = styled.thead`
  color: ${({ theme }) => theme.freecode.color};
  letter-spacing: 1px;
`;

export const TableBody = styled.tbody`
  color: ${({ theme }) => theme.freecode.color};
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 0px;
`;

export const TableData = styled.td`
  text-align: left;
  padding: 0px;
`;
